/**
 * 当前一周中的第几天（周日 = 0）
 */
export const DAY_FIELD = '$$day$$';
/**
 * 当前是一年中的第几周
 */
export const WEEK_FIELD = '$$week$$';
/**
 * 日期字段，Date 类型
 */
export const DATE_FIELD = '$$date$$';
/**
 * 数据处理阶段，标记这周是否是当月中间
 */
export const IS_MONTH_CENTER_FIELD = '$$is_month_center$$';
/**
 * 格式化日期
 */
export const FORMATTER = 'YYYY-MM-DD';
/**
 * 月份枚举
 */
export const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
/**
 * 周枚举
 */
export const WEEKS = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
